import { formatTimestamp } from "./file-system-utils.js";
//#region ../src/storage/null-storage-backend.ts
var NullStorageBackend = class {
	createSession(timestamp, _contextTag) {
		return Promise.resolve({ sessionName: `recording-${formatTimestamp(timestamp)}` });
	}
	listSessions() {
		return Promise.resolve([]);
	}
	async writeAction(_action, _index) {}
	async writeFrame(_blob, _index) {}
	async writeSessionMetadata(_metadata) {}
};
//#endregion
export { NullStorageBackend };
